import { render, staticRenderFns } from "./JobCard.vue?vue&type=template&id=2fcac578&scoped=true&"
import script from "./JobCard.vue?vue&type=script&lang=js&"
export * from "./JobCard.vue?vue&type=script&lang=js&"
import style0 from "./JobCard.vue?vue&type=style&index=0&id=2fcac578&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcac578",
  null
  
)

export default component.exports